<template>
    <tbody style="position: relative;">
        <Tooltip
            v-bind:hideIcon="this.hideIcon"
            v-bind:showCommentTooltip="this.showCommentTooltip"
            v-bind:comment="comment"
        />
        <tr class="new-row-animation">
            <td
                v-bind:class="{ 'wide-timestamp': hideIcon }"
                class="tx-table-time clickable-row"
                v-on:mouseover="showTimeTooltip = true"
                v-on:mouseleave="showTimeTooltip = false"
            >
                <router-link class="simple-table-link" v-bind:to="txLink">
                    <div v-if="finality === 'pending'" class="tx-table-time__value muted">
                        <icon-tx-pending class="tx-pending-icon tx-pending-icon__desktop" />
                        {{ $t('address.tx_table.pending') }}
                    </div>
                    <!--
                    <div v-else-if="finality === 'confirmed'" class="tx-table-time__value muted">
                        <icon-tx-confirmed class="tx-confirmed-icon__desktop" />
                        {{ $t('address.tx_table.confirmed') }}
                    </div>
                    <div v-else-if="finality === 'signed'" class="tx-table-time__value muted">
                        <icon-tx-success class="tx-confirmed-icon__desktop" />
                        {{ $t('tx.status_success') }}
                    </div>
                    -->
                    <div v-else class="tx-table-time__value muted">
                        <ui-timeago class="tx-table-time__cell" v-bind:timestamp="timestamp"/>
                        <ui-tooltip
                            v-bind:value="formattedTimestamp "
                            position="right"
                            v-if="showTimeTooltip"
                        />
                    </div>
                <!-- formattedTimestamp -->
                <!-- v-if="showTimeTooltip && this.$store.state.timeFormatData == 'absolute'" -->
                </router-link>
            </td>
            <td class="clickable-row">
                <router-link class="simple-table-link" v-bind:to="txLink">
                    <DesktopEventIcon
                        v-if="event"
                        v-bind:event="event"
                        v-bind:is_success="is_success"
                        v-bind:is_out="isOut"
                        v-bind:meta="meta"
                    />
                </router-link>
            </td>
            <td class="clickable-row">
                <router-link class="simple-table-link" v-bind:to="txLink">
                    <div class="tx-table__cell">
                        <span v-if="is_external || event === 'external'" class="muted" v-text="$t('address.tx_table.external')"/>
                        <!-- Toncenter could not classify the trace, so there is no counterparty to name: -->
                        <span v-else-if="event === 'unknown'" class="muted" v-text="$t('common.empty')"/>
                        <span v-else-if="event === 'contract_deploy'">
                            <ui-address v-bind:address="receiver"
                                v-bind:type="destination_type"
                                v-bind:alias="destination_alias"
                                style="max-width: 230px;"
                            />
                        </span>
                        <template v-else-if="event === 'nft_purchase'">
                            <span class="muted" style="margin-right: 4px">
                                <template v-if="isOut">{{ $t('address.all_tx_table.to') }}</template>
                                <template v-else>
                                    <span v-if="meta?.marketplace">{{ $t('transactionPage.on') }}</span>
                                    <span v-else>{{ $t('address.all_tx_table.from') }}</span>
                                </template>
                            </span>

                            <ui-address v-if="isOut" v-bind:address="receiver"
                                v-bind:type="destination_type"
                                v-bind:alias="destination_alias"
                                style="max-width: 230px;"
                                v-bind:disabled="address === receiver"
                            />
                            <template v-else>
                                <ui-address v-if="meta?.marketplace && meta.marketplace === 'fragment'" address="UQBAjaOyi2wGWlk-EDkSabqqnF-MrrwMadnwqrurKpkla4QB" />
                                <span style="text-transform: capitalize" v-else-if="meta?.marketplace">
                                    {{ meta.marketplace }}
                                </span>
                                <ui-address v-else v-bind:address="sender"
                                    v-bind:type="source_alias"
                                    v-bind:alias="source_alias"
                                    style="max-width: 230px;"
                                />
                            </template>
                        </template>
                        <template v-else>
                            <span v-if="event === 'jetton_swap' && !isDEX" class="muted" style="margin-right: 4px">
                                {{ $t('transactionPage.on') }}
                            </span>
                            <span v-else-if="event === 'nft_purchase' || event === 'deploy_nft'"><!-- Empty --></span>
                            <span v-else class="muted" style="margin-right: 4px">
                                <template v-if="!isOut">{{ $t('address.all_tx_table.from') }}</template>
                                <template v-else>{{ $t('address.all_tx_table.to') }}</template>
                            </span>

                            <span v-if="meta?.dex === 'dedust' && !isDEX">
                                <a href="https://dedust.io/" target="_blank">DeDust</a>
                            </span>
                            <ui-address v-else-if="event === 'deploy_nft'"
                                v-bind:address="action.nft"
                            />
                            <ui-address v-else v-bind:address="isOut ? receiver : sender"
                                v-bind:type="isOut ? destination_type : source_type"
                                v-bind:alias="isOut ? destination_alias : source_alias"
                                style="max-width: 230px;"
                            />
                        </template>
                    </div>
                </router-link>
            </td>

            <td v-if="showTxComments" class="tx-table-comment-cell clickable-row">
                <router-link class="simple-table-link" v-bind:to="txLink">
                    <div class="tx-table__cell tx-table__cell--comment">
                        <span class="tx-table-comment" v-bind:title="comment" v-text="comment"/>
                    </div>
                </router-link>
            </td>

            <!-- Transaction value (TON amount or action): -->
            <td class="column-wide clickable-row">
                <router-link class="simple-table-link" v-bind:to="txLink">
                    <div class="tx-table__cell tx-table__cell--align-right tx-table__value">
                        <action-badge
                            v-if="canShowActionBadge"
                            v-bind:class="{'muted': !is_success}"
                            v-bind:action="action"
                            v-bind:amount="amount"
                            v-bind:op="op"
                            v-bind:meta="meta"
                            v-bind:from="from"
                            v-bind:to="to"
                            v-bind:is_out="isOut"
                            v-bind:event="event"
                            v-bind:is_success="is_success"
                        />

                        <div v-bind:class="{'muted': !is_success}" v-else>
                            <!-- Nothing is known about the value of an unrecognized operation,
                                 its place is taken by a shortcut to the filter that hides them: -->
                            <button v-if="event === 'unknown'" class="tx-hide-unknown"
                                v-on:click.prevent.stop="hideUnknown"
                                v-text="$t('common.hide')"/>

                            <div v-else-if="[
                                     'jetton_burn',
                                     'jetton_mint',
                                     'auction_bid',
                                 ].includes(event)"
                                v-bind:class="{
                                    'tx-amount--in': !isOut,
                                }"
                            >
                                <span v-if="isOut">&minus;</span>
                                <tx-amount v-bind:amount="amount" v-bind:decimals="meta?.decimals ?? 9" />
                                <ui-link v-if="meta.jetton_address" class="tx-table-jetton-link-standart"
                                    v-bind:to="{ name: 'token', params: {
                                        address: meta.jetton_address,
                                    }}">
                                    {{displayTicker(meta?.jetton?.symbol || meta?.symbol, meta?.jetton_address)}}
                                </ui-link>
                                <template v-else>
                                    {{displayTicker(meta?.jetton?.symbol || meta?.symbol, meta?.jetton_address)}}
                                </template>
                            </div>

                            <span v-else-if="[
                                      'sent_jetton',
                                      'received_jetton',
                                  ].includes(event)"
                                v-bind:class="{
                                    'ui-inline-jetton--green': !isOut && !is_success,
                                }"
                            >
                                <tx-amount v-bind:amount="amount" v-bind:decimals="meta?.decimals ?? 9" />
                                <ui-link
                                    style="margin-left: 5px;"
                                    v-bind:to="{ name: 'token', params: {
                                        address: meta.jetton_address,
                                    }}">
                                    {{displayTicker(meta?.jetton?.symbol || meta?.symbol, meta?.jetton_address)}}
                                </ui-link>
                            </span>

                            <template v-else-if="event && event.endsWith('_dns') && meta?.domain">
                                <ui-link
                                    style="margin-left: 5px"
                                    class="ui-inline-domain ui-inline-domain--blue router-link__no-style"
                                    v-bind:to="{ name: 'nft', params: {
                                        address: to,
                                    }}">
                                    {{truncateDomain(meta.domain)}}
                                </ui-link>
                            </template>

                            <template v-else-if="is_external || [
                                'external',
                            ].includes(event)">
                                <span class="muted" v-text="$t('common.empty')"/>
                            </template>

                            <!-- Events without TON amount -->
                            <div class="muted"
                                v-else-if="[
                                    'unsubscribe',
                                    'external',
                                ].includes(event)
                                ">
                                {{$t(`events.${event}`)}}
                            </div>

                            <template v-else-if="['change_dns', 'renew_dns'].includes(event)">
                                <ui-link
                                    style="margin-left: 5px;"
                                    v-bind:to="{ name: 'address', params: {
                                        address: to,
                                    }}">
                                    {{truncateDomain(meta.domain)}}
                                </ui-link>
                            </template>

                            <template v-else-if="!amount">
                                <!--<span class="muted">{{ $t('common.empty') }}</span>-->
                            </template>

                            <template v-else>
                                <div
                                    v-bind:class="{
                                        'muted': !is_success,
                                        'tx-amount--in': !isOut && is_success,
                                    }"
                                >
                                    <span v-if="isOut">&minus;</span>
                                    <tx-amount v-bind:amount="amount" /> GRAM
                                </div>
                            </template>
                        </div>

                        <icon-encrypted-message v-once class="tx-table-operation-icon" v-if="encrypted || op === '0x2167da4b'"/>
                        <div class="tx-table-comment-icon">
                            <icon-message class="tx-table-operation-icon" v-if="comment && !showTxComments"
                                v-on:mouseenter.native="showCommentTooltip = true"
                                v-on:mouseleave.native="showCommentTooltip = false"
                            />
                            <!-- Takes the comment's place, a comment wins: -->
                            <tx-gasless-icon v-else-if="gasless_parent && !encrypted && op !== '0x2167da4b'" />
                            <ui-tooltip
                                v-bind:value="comment"
                                position="left"
                                v-if="showCommentTooltip"
                            />
                        </div>
                    </div>
                </router-link>
            </td>

            <!-- Expand chevron (hidden): -->
            <td>
                <!--<div class="tx-table__cell" v-if="!hideIcon">-->
                <!--    <icon-expand class="tx-table-expand-caret" v-bind:class="{-->
                <!--        'tx-table-expand-caret&#45;&#45;expanded': isVisible,-->
                <!--    }"/>-->
                <!--</div>-->
            </td>
        </tr>
    </tbody>
</template>

<script>
import $bus from '~/eventBus.js';
import { mapState } from 'vuex';
import { isSameAddress } from '~/tonweb.js';
import { displayTicker } from '~/helpers.js';
import { base64ToHex } from '~/utils.js';
import IconMessage from '@img/icons/tonscan/message-14.svg?vue';
import IconEncryptedMessage from '@img/icons/tonscan/encrypted-message.svg?vue';
import IconTxPending from '@img/icons/tonscan/round-loader.svg?vue';
// import IconTxConfirmed from '@img/icons/lucide/check.svg?vue';
// import IconTxSuccess from '@img/icons/lucide/check-check.svg?vue';
import ActionBadge from './TxRowActionBadge.vue';
import DesktopEventIcon from './DesktopEventIconSimple.vue';
import Tooltip from '../other/Tooltip.vue';
import TxAmount from './TxSimpleInlineAmount.vue';
import TxGaslessIcon from './TxGaslessIcon.vue';

export default {
    props: {
        address: String,
        date: String,
        from: String,
        is_service: Boolean,
        is_external: Boolean,
        is_aggregated: Boolean,
        is_success: Boolean,
        is_bounced: Boolean,
        is_swapped: Boolean,
        outputCount: Number,
        to: String,
        amount: String,
        message: String,
        timestamp: Number,
        fee: String,
        txHash: String,
        txLt: String,
        exitCode: Number,
        op: [Number, String],
        source_type: String,
        destination_type: String,
        source_alias: String,
        destination_alias: String,
        action: Object,
        event: String,
        meta: {
            type: Object,
            default: () => ({}),
        },
        hideIcon: Boolean,
        encrypted: Boolean,
        gasless_parent: String,
        finality: {
            type: String,
            default: () => 'finalized',
        },
    },

    data() {
        return {
            isVisible: false,
            showTimeTooltip: false,
            showCommentTooltip: false,
        };
    },

    computed: {
        ...mapState({ dataSource: 'txTableSource', showTxComments: 'showTxComments' }),

        currentAccountContractType() {
            return this.isOut
                ? this.source_type
                : this.destination_type;
        },

        canShowActionBadge() {
            const isNftMessage = ((this.action && this.action?.type) || '').startsWith('nft:');

            // Avoid duplicates in events table
            if (this.event === 'jetton_burn') return false;

            // show nft badges only if they are opened on the wallet page:
            if (isNftMessage) {
                return this.currentAccountContractType === 'wallet';
            }

            return !!this.action;
        },

        sender() {
            // don't replace sender with decoded body data
            // unless we are on the wallet page:
            if (!this.canShowActionBadge) {
                return this.from;
            }

            switch (this.action?.type) {
                case 'jetton:transfer_notification':
                    return this.action.sender;

                case 'nft:ownership_assigned':
                    return this.action.prev_owner;

                default:
                    return this.from;
            }
        },

        receiver() {
            // don't replace receiver with decoded body data
            // unless we are on the wallet page:
            if (!this.canShowActionBadge) {
                return this.to;
            }

            switch (this.action?.type) {
                case 'jetton:transfer':
                    return this.action.destination;

                case 'nft:transfer':
                    return this.action.new_owner;

                default:
                    return this.to;
            }
        },

        comment() {
            return this.message || this.action?.forward_payload;
        },

        isOut() {
            // On a jetton wallet page the address is the wallet, and the sender is its owner:
            return this.event === 'sent_jetton' || this.isSame(this.from, this.address);
        },

        isDEX() {
            const dexes = [
                'EQB3ncyBUTjZUA5EnFKR5_EnOMI9V1tTEAAPaiU71gc4TiUt', // stonfi
                'EQDa4VOnTYlLvDJ0gZjNYm5PXfSmmtL6Vs6A_CZEtXCNICq_', // dedust
            ];

            return dexes.includes(this.address);
        },

        baseHex() {
            return base64ToHex(this.txHash);
        },

        formattedTimestamp() {
            return this.formatTimestamp(this.timestamp);
        },

        txLink() {
            return {
                name: 'tx',
                params: { hash: this.baseHex },
            };
        },
    },

    created() {
        $bus.$on('tx-close-all', () => {
            this.isVisible = false;
        });
    },

    beforeDestroy() {
        $bus.$off('tx-close-all');
    },

    methods: {
        displayTicker,

        // Unknown operations belong to the «Contract calls» filter group:
        hideUnknown() {
            if (!this.$store.state.excludeGroups.includes('contractCall')) {
                this.$store.commit('toggleExcludeActionGroup', 'contractCall');
            }
        },

        isSame(a, b) {
            return isSameAddress(a, b);
        },

        formatTimestamp(ts) {
            const date = new Date(ts);

            // Получаем компоненты даты
            const day = String(date.getDate()).padStart(2, '0'); // ДД
            const month = String(date.getMonth() + 1).padStart(2, '0'); // ММ (месяцы начинаются с 0)
            const year = String(date.getFullYear()).slice(-2); // ГГ (последние две цифры года)

            // Получаем компоненты времени
            const hours = String(date.getHours()).padStart(2, '0'); // ЧЧ
            const minutes = String(date.getMinutes()).padStart(2, '0'); // ММ
            const seconds = String(date.getSeconds()).padStart(2, '0'); // СС

            // Формируем строку в нужном формате
            return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
        },

        truncateDomain(domain) {
            if (domain && domain.length > 20) {
                return domain.slice(0, 8) + '...' + domain.slice(-8);
            }
            return domain;
        },
    },

    components: {
        ActionBadge,
        IconMessage,
        IconEncryptedMessage,
        IconTxPending,
        // IconTxConfirmed,
        // IconTxSuccess,
        DesktopEventIcon,
        TxAmount,
        TxGaslessIcon,
        Tooltip,
    },
};
</script>

<style lang="scss">
.comment-tooltip {
    position: absolute;
    object-position: bottom;
    right: 40px;
    height: auto;
    top: 6px;
    border: 1px solid var(--card-border-color);
    border-radius: 12px;
    box-shadow: 0 .5rem 1.2rem var(--card-box-shadow-color);
    padding: 12px 14px;
    background-color: var(--body-background);
    z-index: 99999;
    transition: .3s;
    max-width: 300px;

    // Make triangle tail
    &::after {
        content: '';
        display: block;
        position: absolute;
        top: 10px;
        right: -8px;
        width: 8px;
        height: 8px;
        background: var(--body-background);
        border-right: 1px solid var(--card-border-color);
        border-bottom: 1px solid var(--card-border-color);
        transform: rotateZ(-45deg) translateX(-4.3px);
    }
}

// Takes only the room left by the other columns, so a long comment never pushes the value off screen:
.tx-table .tx-table-comment-cell {
    width: 100%;
    max-width: 0;
}

.tx-table-comment {
    overflow: hidden;
    text-overflow: ellipsis;
}

// Make timestamp for events table, so addreses would be in the center
.wide-timestamp {
    min-width: 220px;
}

.comment-tooltip-animation-enter-to, .comment-tooltip-animation-leave {
    opacity: 1;
}
.comment-tooltip-animation-enter, .comment-tooltip-animation-leave-to {
    opacity: 0;
}
.tx-table-time {
    position: relative;

    &__cell {
        display: flex;
        align-items: center;
        max-width: 100%;
        box-sizing: border-box;
        width: 100%;
    }

    &__value {
        display: inline-block;
        position: relative;
        margin: 0 18px;
    }
}

.ui-inline-domain {
    padding: 5px 10px;
    margin: -4px 0;
    font-size: 13px;
    font-weight: 600;
    border-radius: 6px;
    background-color: rgba(1, 105, 255, .15);
    color: var(--blue-bright);
    transition: .2s;

    &:hover {
        background-color: rgba(1, 105, 255, .23);
    }
}

@media screen and (max-width: 1149px) {
    .wide-timestamp {
        min-width: auto;
    }
}
</style>
